import React from 'react';
import { Reveal } from './Reveal';
const withoutItems = ['😓 Winging every session with no clear structure', '🔁 Helping clients but feeling uncertain about what you did', '💭 Charging less because you don’t feel credible', '😰 No documentation, no follow-up, no client tracking', '🌙 Working alone without training frameworks'];
const withItems = ['📖 Open your session protocol', '🎯 Know exactly what to do, when to do it, and why', '💪 Charge professional rates with absolute confidence', '📋 Document everything. Track results. Build your reputation.', '🎓 Train others from a proven system'];
type PanelProps = {
  title: string;
  label: string;
  items: string[];
  positive?: boolean;
};
function Panel({
  title,
  label,
  items,
  positive
}: PanelProps) {
  return <div className={`p-7 sm:p-10 ${positive ? 'bg-surface' : 'bg-mist'}`} data-id="element-29" data-mp="9ke0951pgg0m">
      <p className={`text-xs font-bold uppercase tracking-[0.16em] ${positive ? 'text-sage' : 'text-red-600'}`} data-id="element-30" data-mp="eiz2tb4fjbs8">
        {label}
      </p>
      <h3 className="mt-4 font-serif text-3xl leading-tight text-navy" data-id="element-31" data-mp="1m20fwauekn64">{title}</h3>
      <ul className="mt-7 divide-y divide-navy/10" data-id="element-32" data-mp="1h8fq362yqzi0">
        {items.map(item => <li key={item} className="py-4 text-sm leading-relaxed text-slate sm:text-base" data-id="element-33" data-mp="1d9gnhs4pfetq">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function Comparison() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-34" data-mp="24ya25lfgkk17">
      <div className="mx-auto max-w-6xl" data-id="element-35" data-mp="20y9dl7ynasgf">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-36" data-mp="20zax80tq8n9r">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-37" data-mp="1vyn2b42dnma9">
            ⚖️ The Difference a <span className="text-sage" data-id="element-38" data-mp="1r029vqtda6wd">Real System</span> Makes
          </h2>
          <p className="mt-5 text-slate" data-id="element-39" data-mp="1r1wnek2b6wqf">
            You’re not buying files. You’re buying a complete professional operating system.
          </p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-40" data-mp="fjvihfjarnck">
          <div className="mt-10 overflow-hidden rounded-2xl border border-navy/10 shadow-elevated md:grid md:grid-cols-2" data-id="element-41" data-mp="fmq2x72b985z">
            <Panel label="❌ WITHOUT" title="Without Therapeutic Reiki Guide" items={withoutItems} data-id="element-42" data-mp="m0n8syfbkq1e" />
            <Panel positive label="✅ WITH" title="With Therapeutic Reiki Guide" items={withItems} data-id="element-43" data-mp="80m5lcbl16ir" />
          </div>
        </Reveal>
      </div>
    </section>;
}